import { type QueryHookOptions, useQuery } from "@apollo/client";
import { AnalyticsUsersByDateQuery } from "../graphql/queries";
import type {
  AnalyticsUsersByDateQueryType,
  AnalyticsUsersByDateQueryVariablesType,
} from "@/types/graphql/partner.generated";

export const useAnalyticsUsersByDateQuery = (
  options?: QueryHookOptions<
    AnalyticsUsersByDateQueryType,
    AnalyticsUsersByDateQueryVariablesType
  >
) => {
  return useQuery<
    AnalyticsUsersByDateQueryType,
    AnalyticsUsersByDateQueryVariablesType
  >(AnalyticsUsersByDateQuery, options);
};
